<template>
  <div class="py-12 bg-gray-100 min-h-screen flex flex-col items-center">
    <div v-html="content" class="w-full overflow-hidden prose"></div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      content: `<h1>Sample page template</h1><p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Libero eaque laudantium ratione
        architecto qui at! Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda et
        saepe necessitatibus, corporis praesentium velit reprehenderit debitis fugiat? At enim atque
        quod ratione molestias distinctio corporis placeat nesciunt! Iste eum blanditiis doloremque,
        deleniti error recusandae animi natus quia voluptate cupiditate fugit nihil molestiae
        necessitatibus ea? Dolorem quae suscipit consequuntur quia.</p><h2>Subheading</h2><p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Libero eaque laudantium ratione
        architecto qui at! Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda et
        saepe necessitatibus, corporis praesentium velit reprehenderit debitis fugiat?</p><i>Lorem ipsum dolor sit amet</i><p>It includes syntax highlighting to make the HTML filtering. You can also switch to WYSIWYG mode anytime to check how your code output looks!</p>
<p><strong>We use cookies and other technologies to provide you with a better user experience.</strong></p>`,
    };
  },
};
</script>
